<script>
import { HorizontalBar } from "vue-chartjs";
// import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";
export default {
  extends: HorizontalBar,
  // plugins: [ChartJSPluginDatalabels],
  props: ["title", "data", "labels"],
  data() {
    return {};
  },
  mounted() {
    this.load();
  },
  watch: {
    data() {
      this.load();
    },
  },
  methods: {
    load() {
      this.renderChart(
        {
          labels: this.$props.labels,
          datasets: [
            {
              label: this.$props.title,
              maxBarThickness: 30,
              backgroundColor: "#5E83BA",
              data: this.$props.data,
              datalabels: {
                display: false,
                align: "right",
                anchor: "end",
                color: "#898989",
                borderWidth: 2,
                padding: {
                  bottom: 0,
                  left: 20,
                },
              },
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: this.$props.labels.length > 10 ? true : false,
          tooltips: {
            mode: "index",
            intersect: false,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  min: 0,
                  // stepSize: 20000,
                },
              },
            ],
          },
        }
      );
    },
  },
};
</script>
